import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, take, mergeMap, tap } from 'rxjs';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { Pathbar } from 'src/app/lem/models/common/pathbar';
import { Person } from 'src/app/lem/models/person/person';
import { PersonService } from '../../services/person.service';
import { PersonType } from 'src/app/lem/models/person/person-type';

@Component({
  selector: 'app-detail-person',
  templateUrl: './detail-person.component.html',
  styleUrls: ['./detail-person.component.css'],
  host: { '[attr.id]': '\'content\'' }
})
export class DetailPersonComponent {

  person: Person;
  personTypes: PersonType[];
  pathbars: Pathbar[] = [];


  constructor(
    private viewManager: ViewManagerService,
    private route: ActivatedRoute,
    private personService: PersonService,
  ) {

    this.personService.getAllType().subscribe((types)=>{this.personTypes = types;})

  }


  ngOnInit(): void {
    this.viewManager.svuotaMenu();
    this.populatePerson().subscribe(res => this.populatePathbar());
  }

  populatePerson(): Observable<Person> {
    return this.route.params.pipe(
      take(1),
      mergeMap((params) => {
        return this.personService.findById(params['id']);
      }),
      tap((person: Person) => this.person = person),
    );
  }

  private populatePathbar() {
    this.pathbars.push({ path: "/rubrica", title: "Vai alla rubrica", description: "Rubrica" });
    this.pathbars.push({ path: "/rubrica/dettaglio/" + this.person?.id, title: "", description: "Gestione persona" });
  }

  getTypeValue(type: string){
    return this.personTypes.find(el => el.id == type).name;
  }

}
